import Vue from 'vue';

import axios from 'axios';
import qs from 'qs';

axios.interceptors.request.use(function (config) {
  config.headers['Cache-Control'] = 'no-cache';
  config.headers['Pragma'] = 'no-cache';
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  if (error.response.status === 401) {
    // 非线上不做跳转登录页处理
    if (!process || process.env.NODE_ENV === 'production') {
      vm.$message.error('登录失效，请重新登录');
      setTimeout(() => {
        localStorage.clear();
        window.location.href = '/account-web';
      }, 1000);
    }
  }
  return Promise.reject(error);
});

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$agency = {};



// WEBPACK FOOTER //
// ./src/components/core/registerAjax.js